export const SET_CURRENT_DRIVER_CARD_ON_MAP = 'SET_CURRENT_DRIVER_CARD_ON_MAP';
export const REMOVE_CURRENT_DRIVER_CARD_ON_MAP = 'REMOVE_CURRENT_DRIVER_CARD_ON_MAP';

export function setCurrentDriverCardOnMap(driver, lat, lng) {
  return {
    type: SET_CURRENT_DRIVER_CARD_ON_MAP,
    payload: {
      driver: driver,
      lat: lat,
      lng: lng
    }
  }
}

export function removeCurrentDriverCardOnMap() {
  return {
    type: REMOVE_CURRENT_DRIVER_CARD_ON_MAP
  }
}



// WEBPACK FOOTER //
// ./src/components/available-drivers-map/available-drivers-map-actions.js